import {
  parseLineLoginRequest,
  parseSessionResponse
} from "@madamuh/domain";
import type { LineLoginRequestDto, SessionResponseDto } from "@madamuh/domain";
import { apiGet, apiPost } from "./client";

export async function fetchCurrentSession(): Promise<SessionResponseDto> {
  const response = await apiGet<unknown>("/api/v1/session/me");
  return parseSessionResponse(response);
}

export async function postLineLogin(request: LineLoginRequestDto): Promise<SessionResponseDto> {
  const parsedRequest = parseLineLoginRequest(request);
  const response = await apiPost<LineLoginRequestDto, unknown>("/api/v1/session/line-login", parsedRequest);
  return parseSessionResponse(response);
}
